import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#005FCC",
  },
  "& span.MuiInputLabel-asterisk": {
    color: "#FF9800",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderRadius: "8px",
      borderColor: "#005FCC",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#005FCC",
      borderWidth: "1px",
    },
  },
  input: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
      backgroundColor: "#fff",
    },
  },
});

export default CssTextField;
